import { BaseIcon, VisibaCortexBaseIconProps } from '@components/base_icon.component';
import { dangerouslyInjectHTML } from '@visiba/react-std';
import styled from 'styled-components';
import loadedIconSet from '../_visiba_icon_set.json'; // 👉 ⚠ ⚠ ⚠ run "$ pnpm loadIconSet" if this module is not found ⚠ ⚠ ⚠
import { ErrorBoundary } from './error_boundary.component';

interface Dictionary {
	rocket: string;
	arrowRight: string;
	globe: string;
	letter: string;
	avatar: string;
	avatars: string;
	cross: string;
	sendMessageArrow: string;
	consultation: string;
	units: string;
	units_filled: string;
	home: string;
	home_filled: string;
	messagingHistory: string;
	calendar: string;
	queue: string;
	settings_filled: string;
	settings_outline: string;
	visits: string;
	visits_filled: string;
	mail: string;
	eva_globe: string;
	search: string;
	home2: string;
	building: string;
	noConnection: string;
	microphoneDisabled: string;
	microphoneEnabled: string;
	videoDisabled: string;
	videoEnabled: string;
	phone: string;
	phoneError: string;
	soundDisabled: string;
	soundEnabled: string;
	warning: string;
	phone_warning: string;
	chat: string;
	screenShare: string;
	RR_man: string;
	RR_myself: string;
	volumeMeter: string;
	zoomIn: string;
	zoomOut: string;
	hand: string;
	sendAttachment: string;
	downloadFile: string;
	arrowLeft: string;
	nonPicFile: string;
	unknownFileType: string;
	arrow_right: string;
	attentionCardArrow: string;
	messaging: string;
	alertive: string;
	alertiveCreditCard: string;
	form: string;
	clock: string;
	error: string;
	file_blank: string;
	file_excel: string;
	file_pdf: string;
	file_unknown: string;
	file_word: string;
	file_error: string;
	file_download__error: string;
	file_download__success: string;
	check: string;
	gridView: string;
	speakerView: string;
	dots: string;
	scrollToTopArrow: string;
	minimize: string;
	maximize: string;
	arrowDown: string;
	arrowUp: string;
	remove_call_participant: string;
	remove_call_participant_grey: string;
	calendar_noPickedDate: string;
	email: string;
	phone_phoneNumber: string;
	authenticated_way: string;
	representative: string;
	hourglass: string;
	timeClock: string;
	pinFilled: string;
	pinOutlined: string;
	unpinOutlined: string;
	information: string;
}

type IconMap = {
	[key in keyof Dictionary]: {
		innerHTML: string;
		viewBox: string;
	};
};

export type IconType = keyof Dictionary;

interface Props extends Omit<VisibaCortexBaseIconProps, 'viewBox'> {
	/**
	 * Name of the icon do be displayed
	 */
	type: IconType;
}

const iconMap = loadedIconSet as unknown as IconMap;

const elements = {
	fallback: styled.span`
		width: 1em;
		height: 1em;
		flex-shrink: 0;
	`,
};

/**
 * Icon component for all icons used
 * Deprecated: Use Cellula components instead
 */
export function Icon({ type, ...rest }: Props): JSX.Element {
	return (
		<ErrorBoundary fallback={<elements.fallback>⚠</elements.fallback>}>
			<BaseIcon {...rest} viewBox={iconMap[type].viewBox} dangerouslySetInnerHTML={dangerouslyInjectHTML(iconMap[type].innerHTML)} />
		</ErrorBoundary>
	);
}
